import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const api = process.env.NODE_ENV === "development" ? "/api" : `${process.env.REACT_APP_API}/api`;

export const fetchPdcs = createAsyncThunk("pdc/fetchPdcs", async () => {
  const response = await fetch(`${api}/admin/pdc`, { credentials: "include" });
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) throw new Error(`Unexpected response from API (${response.status})`);
  const data = await response.json();
  if (!response.ok) throw new Error(data?.error?.message || data?.message || String(data));
  return Array.isArray(data) ? data : [];
});

const pdcSlice = createSlice({
  name: "pdc",
  initialState: { items: [], status: "idle", error: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchPdcs.pending, state => { state.status = "loading"; state.error = null; })
      .addCase(fetchPdcs.fulfilled, (state, action) => { state.status = "succeeded"; state.items = action.payload; })
      .addCase(fetchPdcs.rejected, (state, action) => { state.status = "failed"; state.error = action.error.message || "PDC data could not be loaded."; });
  },
});

export default pdcSlice;
